import { render, staticRenderFns } from "./viewWorks.vue?vue&type=template&id=3c46363a"
import script from "./viewWorks.vue?vue&type=script&lang=js"
export * from "./viewWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c46363a')) {
      api.createRecord('3c46363a', component.options)
    } else {
      api.reload('3c46363a', component.options)
    }
    module.hot.accept("./viewWorks.vue?vue&type=template&id=3c46363a", function () {
      api.rerender('3c46363a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/grade/viewWorks.vue"
export default component.exports